module.exports = __webpack_public_path__ + "img/3-(8).86b383e9.jpg";